(function () {
  'use strict';

  /**
   * 第三方快捷支付点击埋点。
   *
   * Shopify 快捷支付按钮使用 closed shadow DOM。这里只监听 Shopify 官方
   * 支持的 composed click 事件元素，不依赖按钮内部 HTML。
   */
  const tracking = window.jiniuTracking;

  if (!tracking) {
    console.error('[SensorsData] Tracking core is unavailable');
    return;
  }

  const EVENT_NAME = 'quick_pay_click';
  const ENTRY_ATTRIBUTE = 'data-jiniu-quick-pay-entry';
  const SESSION_EVENT_NAME = 'jiniu:session';
  const CONTEXT_PROPERTY_NAME = '_jiniu_context_id';
  const PAY_PROPERTY_NAME = '_jiniu_pay_id';
  const CONTEXT_STORAGE_KEY = '_jiniu_context_id';
  const PAY_STORAGE_KEY = '_jiniu_pay_id';
  const VISIT_STORAGE_KEY = '_jiniu_visit_id';
  let latestCartData = null;
  const PAYMENT_METHODS = {
    'shop-pay-wallet-button': {
      paymentMethod: 'shop_pay',
      buttonText: 'Shop Pay'
    },
    'shopify-amazon-pay-button': {
      paymentMethod: 'amazon_pay',
      buttonText: 'Amazon Pay'
    },
    'shopify-apple-pay-button': {
      paymentMethod: 'apple_pay',
      buttonText: 'Apple Pay'
    },
    'shopify-google-pay-button': {
      paymentMethod: 'google_pay',
      buttonText: 'Google Pay'
    },
    'shopify-paypal-button': {
      paymentMethod: 'paypal',
      buttonText: 'PayPal'
    }
  };

  tracking.claimClickEvent(EVENT_NAME);

  document.addEventListener('cart:updated', function (event) {
    if (Array.isArray(event?.detail?.cart?.items)) {
      latestCartData = event.detail.cart;
    }
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    [PUB_SUB_EVENTS.cartItemAdd, PUB_SUB_EVENTS.cartItemRemove, PUB_SUB_EVENTS.cartItemQuantityUpdate].forEach(function (eventName) {
      subscribe(eventName, function (data) {
        if (Array.isArray(data?.cart?.items)) {
          latestCartData = data.cart;
        } else {
          latestCartData = null;
        }
      });
    });
  }

  function toNumber(value) {
    const numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : 0;
  }

  function toPositiveQuantity(value) {
    const quantity = toNumber(value);
    return quantity > 0 ? quantity : 1;
  }

  function toMoneyAmount(value) {
    return toNumber(value) / 100;
  }

  function toSubunitsOrNaN(value) {
    return value === null || value === undefined || value === '' ? NaN : Number(value);
  }

  function multiplyMoney(amount, quantity) {
    return Math.round(toNumber(amount) * toNumber(quantity) * 100) / 100;
  }

  function generatePayId() {
    const cryptoApi = window.crypto;

    if (cryptoApi && typeof cryptoApi.randomUUID === 'function') {
      return cryptoApi.randomUUID();
    }

    const bytes = new Uint8Array(16);

    if (cryptoApi && typeof cryptoApi.getRandomValues === 'function') {
      cryptoApi.getRandomValues(bytes);
    } else {
      for (let index = 0; index < bytes.length; index += 1) {
        bytes[index] = Math.floor(Math.random() * 256);
      }
    }

    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;

    const hex = Array.from(bytes, (byte) =>
      byte.toString(16).padStart(2, '0')
    );

    return [
      hex.slice(0, 4).join(''),
      hex.slice(4, 6).join(''),
      hex.slice(6, 8).join(''),
      hex.slice(8, 10).join(''),
      hex.slice(10, 16).join('')
    ].join('-');
  }

  function getStoredValue(storage, key) {
    try {
      return String(storage.getItem(key) || '').trim();
    } catch (error) {
      return '';
    }
  }

  function setStoredValue(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (error) {
      // Keep using the in-memory value when storage is unavailable.
    }
  }

  function updateSharedCorrelation(values) {
    window.jiniuTrackingCorrelation = {
      ...(window.jiniuTrackingCorrelation || {}),
      ...values
    };
  }

  function getTrackingContext() {
    const getters = [
      tracking.getChainContext,
      tracking.getSessionContext,
      tracking.getContext
    ];

    for (const getter of getters) {
      if (typeof getter !== 'function') {
        continue;
      }

      try {
        const value = getter.call(tracking);

        if (value && typeof value === 'object') {
          return value;
        }
      } catch (error) {
        // Fall through to the session event and stored values.
      }
    }

    const trackingContext =
      tracking.chainContext ||
      tracking.sessionContext ||
      tracking.context;

    if (
      trackingContext &&
      typeof trackingContext === 'object'
    ) {
      return trackingContext;
    }

    return {
      ...(window.jiniuTrackingContext || {}),
      context_id: tracking.context_id || '',
      visit_id: tracking.visit_id || ''
    };
  }

  function getServerContextId() {
    const context = getTrackingContext();
    const contextId = String(
      context.context_id ||
      context.contextId ||
      ''
    ).trim();

    if (contextId) {
      setStoredValue(
        window.sessionStorage,
        CONTEXT_STORAGE_KEY,
        contextId
      );
      updateSharedCorrelation({ context_id: contextId });
      return contextId;
    }

    return (
      getStoredValue(
        window.sessionStorage,
        CONTEXT_STORAGE_KEY
      ) ||
      getStoredValue(
        window.localStorage,
        CONTEXT_STORAGE_KEY
      )
    );
  }

  let memoryPayId = '';

  function getPayId() {
    const storedPayId = getStoredValue(
      window.sessionStorage,
      PAY_STORAGE_KEY
    );

    if (storedPayId) {
      memoryPayId = storedPayId;
      return storedPayId;
    }

    if (!memoryPayId) {
      memoryPayId = generatePayId();
    }

    setStoredValue(
      window.sessionStorage,
      PAY_STORAGE_KEY,
      memoryPayId
    );
    updateSharedCorrelation({ pay_id: memoryPayId });

    return memoryPayId;
  }

  function getChainProperties() {
    const context = getTrackingContext();
    const visitId = String(
      context.visit_id ||
      context.visitId ||
      getStoredValue(
        window.localStorage,
        VISIT_STORAGE_KEY
      )
    ).trim();

    return {
      [CONTEXT_PROPERTY_NAME]:
        getServerContextId() || visitId,
      [PAY_PROPERTY_NAME]: getPayId()
    };
  }

  function isCartAddUrl(value) {
    try {
      const url = new URL(
        String(value || ''),
        window.location.href
      );

      return (
        url.origin === window.location.origin &&
        /^\/cart\/add(?:\.js)?\/?$/.test(url.pathname)
      );
    } catch (error) {
      return false;
    }
  }

  function isCartAddForm(form) {
    return (
      form instanceof HTMLFormElement &&
      isCartAddUrl(form.action)
    );
  }

  function setFormProperty(form, name, value) {
    let input = form.querySelector(
      `input[name="properties[${name}]"]`
    );

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${name}]`;
      form.appendChild(input);
    }

    input.value = value;
  }

  function injectProductFormProperties(root) {
    const forms = [];

    if (root instanceof HTMLFormElement) {
      forms.push(root);
    }

    if (typeof root?.querySelectorAll === 'function') {
      forms.push(
        ...root.querySelectorAll('form[action]')
      );
    }

    forms
      .filter(isCartAddForm)
      .forEach(function (form) {
        const properties = getChainProperties();

        setFormProperty(
          form,
          CONTEXT_PROPERTY_NAME,
          properties[CONTEXT_PROPERTY_NAME]
        );
        setFormProperty(
          form,
          PAY_PROPERTY_NAME,
          properties[PAY_PROPERTY_NAME]
        );
      });
  }

  function addFormDataProperties(formData) {
    const properties = getChainProperties();
    const itemIndexes = new Set();

    for (const key of formData.keys()) {
      const match = String(key).match(
        /^items\[(\d+)\]\[/
      );

      if (match) {
        itemIndexes.add(match[1]);
      }
    }

    const prefixes = itemIndexes.size > 0
      ? Array.from(
          itemIndexes,
          (index) => `items[${index}][properties]`
        )
      : ['properties'];

    prefixes.forEach(function (prefix) {
      formData.set(
        `${prefix}[${CONTEXT_PROPERTY_NAME}]`,
        properties[CONTEXT_PROPERTY_NAME]
      );
      formData.set(
        `${prefix}[${PAY_PROPERTY_NAME}]`,
        properties[PAY_PROPERTY_NAME]
      );
    });
  }

  function mergeJsonItemProperties(item, chainProperties) {
    if (!item || typeof item !== 'object') {
      return item;
    }

    const existingProperties =
      item.properties &&
      typeof item.properties === 'object' &&
      !Array.isArray(item.properties)
        ? item.properties
        : {};

    return {
      ...item,
      properties: {
        ...existingProperties,
        ...chainProperties
      }
    };
  }

  function addJsonProperties(value) {
    if (
      !value ||
      typeof value !== 'object' ||
      Array.isArray(value)
    ) {
      return value;
    }

    const chainProperties = getChainProperties();

    if (Array.isArray(value.items)) {
      return {
        ...value,
        items: value.items.map((item) =>
          mergeJsonItemProperties(
            item,
            chainProperties
          )
        )
      };
    }

    return mergeJsonItemProperties(
      value,
      chainProperties
    );
  }

  function addJsonBodyProperties(body) {
    if (typeof body !== 'string') {
      return body;
    }

    try {
      return JSON.stringify(
        addJsonProperties(JSON.parse(body))
      );
    } catch (error) {
      return body;
    }
  }

  const nativeFetch = window.fetch;

  window.fetch = function (input, init) {
    const requestUrl =
      input instanceof Request
        ? input.url
        : input;

    if (!isCartAddUrl(requestUrl)) {
      return nativeFetch.call(this, input, init);
    }

    if (init?.body instanceof FormData) {
      addFormDataProperties(init.body);
      return nativeFetch.call(this, input, init);
    }

    if (typeof init?.body === 'string') {
      return nativeFetch.call(this, input, {
        ...init,
        body: addJsonBodyProperties(init.body)
      });
    }

    if (
      input instanceof Request &&
      !init?.body
    ) {
      const contentType = String(
        input.headers.get('content-type') || ''
      ).toLowerCase();

      if (contentType.includes('application/json')) {
        return input
          .clone()
          .text()
          .then(function (body) {
            return nativeFetch.call(
              window,
              new Request(input, {
                body: addJsonBodyProperties(body)
              }),
              init
            );
          });
      }

      if (contentType.includes('multipart/form-data')) {
        return input
          .clone()
          .formData()
          .then(function (formData) {
            addFormDataProperties(formData);

            const headers = new Headers(input.headers);
            headers.delete('content-type');

            return nativeFetch.call(
              window,
              new Request(input, {
                body: formData,
                headers
              }),
              init
            );
          });
      }
    }

    return nativeFetch.call(this, input, init);
  };

  function receiveSessionContext(event) {
    const detail =
      event?.detail?.customData ||
      event?.detail ||
      {};
    const contextId = String(
      detail.context_id ||
      detail.contextId ||
      ''
    ).trim();

    if (!contextId) {
      return;
    }

    setStoredValue(
      window.sessionStorage,
      CONTEXT_STORAGE_KEY,
      contextId
    );
    updateSharedCorrelation({ context_id: contextId });
    injectProductFormProperties(document);
  }

  window.addEventListener(
    SESSION_EVENT_NAME,
    receiveSessionContext
  );
  document.addEventListener(
    SESSION_EVENT_NAME,
    receiveSessionContext
  );

  document.addEventListener(
    'submit',
    function (event) {
      if (isCartAddForm(event.target)) {
        injectProductFormProperties(event.target);
      }
    },
    { capture: true }
  );

  injectProductFormProperties(document);

  const observerRoot = document.documentElement;

  if (observerRoot) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node instanceof Element) {
            injectProductFormProperties(node);
          }
        });
      });
    }).observe(observerRoot, {
      childList: true,
      subtree: true
    });
  }

  function parseJsonNode(node) {
    if (!node) {
      return null;
    }

    try {
      const value = JSON.parse(node.textContent || '');
      return value && typeof value === 'object' ? value : null;
    } catch (error) {
      console.error('[SensorsData] Invalid quick pay JSON data', error);
      return null;
    }
  }

  function getSectionScope(element) {
    return (
      element.closest('[id^="shopify-section-"]') ||
      element.closest('.shopify-section') ||
      document
    );
  }

  function getProductData(entryElement) {
    const scope = getSectionScope(entryElement);
    return parseJsonNode(
      scope.querySelector('script[type="application/json"][data-product-json]')
    );
  }

  function getCartData(entryElement) {
    const scope = getSectionScope(entryElement);
    const cart = parseJsonNode(
      scope.querySelector('script[type="application/json"][data-cart-json]')
    );
    return latestCartData || cart;
  }

  function getCartCommerceItems(cart) {
    const currency = String(cart?.currency || window.jiniuTrackingContext?.currency || '');
    return (Array.isArray(cart?.items) ? cart.items : []).map(function (item) {
      const quantity = toSubunitsOrNaN(item?.quantity);
      let originalUnit = toSubunitsOrNaN(item?.original_price);
      if (!Number.isFinite(originalUnit) && quantity > 0) {
        originalUnit = toSubunitsOrNaN(item?.original_line_price) / quantity;
      }
      if (!Number.isFinite(originalUnit)) {
        originalUnit = toSubunitsOrNaN(item?.price);
      }
      let finalLine = toSubunitsOrNaN(item?.final_line_price);
      if (!Number.isFinite(finalLine)) {
        finalLine = toSubunitsOrNaN(item?.final_price) * quantity;
      }
      const price = Number.isFinite(originalUnit) ? toMoneyAmount(originalUnit) : '';
      const discountAmount = Number.isFinite(originalUnit) && Number.isFinite(quantity) && Number.isFinite(finalLine) ? Math.max(0, toMoneyAmount(originalUnit * quantity - finalLine)) : '';
      return {
        product_id: String(item?.product_id || ''),
        product_name: String(item?.product_title || ''),
        product_handle: String(item?.handle || ''),
        variant_id: String(item?.variant_id || ''),
        msku: String(item?.sku || ''),
        product_type: String(item?.product_type || ''),
        price,
        quantity: Number.isFinite(quantity) ? quantity : '',
        discount_amount: discountAmount,
        currency
      };
    });
  }

  function createEmptyProperties(payment, paymentEntry) {
    return {
      payment_method: payment.paymentMethod,
      payment_entry: paymentEntry,
      button_text: payment.buttonText,
      product_id: '',
      product_name: '',
      variant_id: '',
      msku: '',
      product_type: '',
      price: 0,
      quantity: 0,
      cart_id: '',
      checkout_token: '',
      item_count: 0,
      total_quantity: 0,
      payment_value_before_discount: 0,
      discount_amount: 0,
      payment_value: 0,
      currency: String(window.jiniuTrackingContext?.currency || ''),
      has_coupon: false,
      coupon_codes: '[]',
      coupon_count: 0,
      context_id:
        getChainProperties()[CONTEXT_PROPERTY_NAME],
      pay_id: getPayId()
    };
  }

  function getProductProperties(entryElement, payment) {
    const properties = createEmptyProperties(payment, 'product');
    const product = getProductData(entryElement);
    const form = entryElement.closest('form[action*="/cart/add"]');
    const variantId = String(
      form?.querySelector('[name="id"]')?.value || ''
    );
    const quantity = toPositiveQuantity(
      form?.querySelector('[name="quantity"]')?.value
    );
    const variant = Array.isArray(product?.variants)
      ? product.variants.find((item) => String(item.id) === variantId)
      : null;
    const price = toMoneyAmount(variant?.price);
    const paymentValue = multiplyMoney(price, quantity);

    return {
      ...properties,
      product_id: String(product?.id || ''),
      product_name: String(product?.title || ''),
      variant_id: variantId,
      msku: String(variant?.sku || ''),
      product_type: String(product?.type || ''),
      price,
      quantity,
      item_count: variantId ? 1 : 0,
      total_quantity: variantId ? quantity : 0,
      payment_value_before_discount: paymentValue,
      payment_value: paymentValue,
      commerce_items: [{
        product_id: String(product?.id || ''),
        product_name: String(product?.title || ''),
        product_handle: String(product?.handle || ''),
        variant_id: variantId,
        msku: String(variant?.sku || ''),
        product_type: String(product?.type || ''),
        price: variant?.price === null || variant?.price === undefined ? '' : price,
        quantity,
        discount_amount: '',
        currency: properties.currency
      }]
    };
  }

  function getCouponCodes(cart) {
    const codes = new Set();

    function addDiscount(discount) {
      if (
        !discount ||
        discount.applicable === false ||
        (
          discount.type &&
          String(discount.type).toLowerCase() !== 'discount_code'
        )
      ) {
        return;
      }

      const code = discount.code || discount.title;

      if (code) {
        codes.add(String(code));
      }
    }

    if (Array.isArray(cart?.discount_codes)) {
      cart.discount_codes.forEach(addDiscount);
    }

    if (Array.isArray(cart?.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(addDiscount);
    }

    if (Array.isArray(cart?.items)) {
      cart.items.forEach((item) => {
        if (!Array.isArray(item.discount_allocations)) {
          return;
        }

        item.discount_allocations.forEach((allocation) => {
          addDiscount(allocation?.discount_application);
        });
      });
    }

    return Array.from(codes);
  }

  function getCartProperties(entryElement, payment) {
    const properties = createEmptyProperties(payment, 'cart');
    const cart = getCartData(entryElement);
    const cartToken = String(cart?.token || '');
    if (cartToken) {
      updateSharedCorrelation({ cart_token: cartToken });
    }
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const variantIds = new Set(
      items
        .map((item) => String(item.variant_id || ''))
        .filter(Boolean)
    );
    const totalQuantity = items.reduce(
      (total, item) => total + toNumber(item.quantity),
      0
    );
    const discountAmount = toMoneyAmount(cart?.total_discount);
    const paymentValue = toMoneyAmount(cart?.total_price);
    const originalTotal =
      cart?.original_total_price ??
      items.reduce(
        (total, item) =>
          total +
          toNumber(
            item.original_line_price ??
            item.original_price * toNumber(item.quantity)
          ),
        0
      );
    const couponCodes = getCouponCodes(cart);

    return {
      ...properties,
      cart_id: cartToken,
      item_count: variantIds.size,
      total_quantity: totalQuantity,
      payment_value_before_discount: originalTotal
        ? toMoneyAmount(originalTotal)
        : paymentValue + discountAmount,
      discount_amount: discountAmount,
      payment_value: paymentValue,
      currency: String(
        cart?.currency ||
        window.jiniuTrackingContext?.currency ||
        ''
      ),
      has_coupon: couponCodes.length > 0,
      coupon_codes: JSON.stringify(couponCodes),
      coupon_count: couponCodes.length,
      commerce_items: getCartCommerceItems(cart)
    };
  }

  function getPayment(eventPath) {
    for (const current of eventPath) {
      if (!(current instanceof Element)) {
        continue;
      }

      const payment = PAYMENT_METHODS[current.localName];

      if (payment) {
        return payment;
      }
    }

    return null;
  }

  function getEntryElement(eventPath) {
    return eventPath.find(
      (current) =>
        current instanceof Element &&
        current.hasAttribute(ENTRY_ATTRIBUTE)
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      const eventPath =
        typeof event.composedPath === 'function'
          ? event.composedPath()
          : [];
      const payment = getPayment(eventPath);
      const entryElement = getEntryElement(eventPath);

      if (!payment || !entryElement) {
        return;
      }

      const paymentEntry = entryElement.getAttribute(ENTRY_ATTRIBUTE);
      const properties =
        paymentEntry === 'product'
          ? getProductProperties(entryElement, payment)
          : getCartProperties(entryElement, payment);

      tracking.publish(EVENT_NAME, properties, 'click');
    },
    { capture: true }
  );
})();
